import script from "./FormProject.vue?vue&type=script&setup=true&lang=js"
export * from "./FormProject.vue?vue&type=script&setup=true&lang=js"

import "./FormProject.vue?vue&type=style&index=0&id=bca86470&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bca86470"]])

export default __exports__